import React, { useCallback } from "react";
import LogDisplay from "components/Interactions/LogDisplay";
import { emailLogAPI } from "api/Interactions/EmailsAPI";
import { Column } from "components/Data/DataDisplays/GenericTable";

interface EmailsBottomDrawerProps {
  emailId: number;
}

const EmailsBottomDrawer: React.FC<EmailsBottomDrawerProps> = ({ emailId }) => {
  const fetchLogs = useCallback(() => emailLogAPI.getAllByParentId(emailId), [emailId]);

  const columns: Column<any>[] = [
    { field: "timestamp", label: "Timestamp", type: "datetime" },
    { field: "first_name", label: "First Name", type: "text" },
    { field: "last_name", label: "Last Name", type: "text" },
    { field: "email", label: "Email", type: "text" },
    { field: "subject_sent", label: "Subject", type: "text" },
    { field: "body_sent", label: "Body", type: "text" },
    { field: "success", label: "Success", type: "boolean" },
  ];

  return (
    <LogDisplay
      fetchLogs={fetchLogs}
      columns={columns}
      title="Email Logs"
    />
  );
};

export default EmailsBottomDrawer;
